// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "webpack-assets/" + ({"378":"user","464":"search","837":"bookings"}[chunkId] || chunkId) + "." + {"279":"6c6cafc8f2f34e06731c","378":"b40556ee23d50dd62461","464":"2bc067058d43c87b9427","837":"7f352e7b6ae3d5ae2112","879":"7240dab5c0c7141c67d2"}[chunkId] + ".js";
};